module.exports = __webpack_public_path__ + "img/prehled-mapa_500.3fb022a8.gif";